export enum SentryBreadcrumb {
  Mixpanel = 'MixPanel',
  NetworkConnection = 'NetworkConnection',
  GraphQl = 'GraphQl',
  LSPConnection = 'LSP Connection',
  LSPRequest = 'LSP Request',
  LSPError = 'LSP Error',
  LSPResponse = 'LSP Response',
  LSPNotification = 'LSP Notification',
  LSPChunk = 'LSP Chunk',
  ExecutionRequest = 'Execution Request',
  ExecutionNotification = 'Execution Notification'
}
export enum SentryBreadcrumbType {
  wss = 'wss',
  gql = 'gql'
}
